module["exports"] = [
  "0###",
  "2###",
  "3###",
  "4###",
  "5###",
  "6###",
  "7###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/address/postcode.js
// module id = 760
// module chunks = 0